/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import SettingsContainerContentQuery, {
	type SettingsContainerContentQuery as QueryType,
} from '@jira/servicedesk__queues-config/src/__generated__/SettingsContainerContentQuery.graphql.ts';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JiraServicedeskQueueAri } from '@atlassian/ari/jira-servicedesk/queue';
import type { Match, Route } from '@atlassian/react-resource-router';

const NAVIGATION_ITEMS_PAGE_SIZE = 75;

type QueueEditEmbeddedViewEntryPointComponent = EntryPointComponent<
	{
		SettingsContainerContentQuery: QueryType;
	},
	{},
	{},
	{
		projectKey: string;
		query: {
			config?: string;
		};
		match: Match;
		route: Route;
	}
>;

export const gettingStartedQueueEditEntryPoint: EntryPoint<
	QueueEditEmbeddedViewEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<QueueEditEmbeddedViewEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-getting-started-queue-edit", jiraSpaEntry: "async-servicedesk-getting-started-queue-edit" */ '@jira/servicedesk__solution-composer-embeds/src/QueueEditEmbeddedView.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: { match, query, route },
		tenantContext: { activationId, cloudId },
	}: EntryPointRouteParams) => {
		const projectKey = match.params.projectKey;
		const queueId = match.params.queueId ?? '';

		if (!projectKey) {
			throw new Error('projectKey is required');
		}

		const queueAri = queueId
			? JiraServicedeskQueueAri.create({
					siteId: cloudId,
					queueId,
					activationId,
				}).toString()
			: '';

		const input = queueAri ? { scopeId: queueAri } : { projectKeyQuery: { cloudId, projectKey } };

		return {
			queries: {
				SettingsContainerContentQuery: {
					parameters: SettingsContainerContentQuery,
					variables: {
						input,
						first: NAVIGATION_ITEMS_PAGE_SIZE,
					},
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
			},
			extraProps: {
				projectKey,
				query,
				match,
				route,
			},
		};
	},
});
